import React, { useEffect } from "react";

import "./login.css";
import { useParams } from "react-router-dom";

import { toast } from "react-toastify";

import AdminListService from "../../../services/admin-list.service";

import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { actionCreaters } from "../../../Redux";

export default function VerifyUser() {
  const dispatch = useDispatch();
  const userActions = bindActionCreators(actionCreaters, dispatch);
  const { id, type } = useParams();

  const loginBrpwse = async () => {
    try {
      const response = await AdminListService.getAzureLoginUserInfo(id, type);

      if (response.status === 200) {
        await userActions.logIn(
          {
            customerAccessToken: response.data.data.access_token,
            customer_id: response.data.data.AdminId,
            customerSiteId: response.data.data.SiteId,
          },
          "customerLogin",
        );
        window.location.href = "/upload-file";
      }
    } catch (err) {
      console.log(err);

      setTimeout(() => {
        window.location.href = "/";
      }, 2000);

      if (
        err?.response?.data?.message &&
        typeof err?.response?.data?.message === "string"
      ) {
        toast.error(err?.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        toast.error("Something went wrong, try again", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    }
  };
  useEffect(() => {
    if (id) {
      loginBrpwse();
    }
  }, [id]);
  return (
    <div className={`loader in with-verify`}>
      <div className="spinner-border main-spin"></div>
    </div>
  );
}
